export default __webpack_public_path__ + "static/media/partner-landing-international.f05ae2fd.jpg";